import clsx from 'clsx';

import { FieldWrapper } from './FieldWrapper';

export const InputField = (props) => {
  const {
    type = 'text',
    className,
    onChange,
    maxLength,
    disabled,
    placeholder,
    value,
    registration,
    error,
    required,
  } = props;

  return (
    <FieldWrapper error={error}>
      <input
        type={type}
        maxLength={maxLength}
        value={value}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        className={clsx(
          'appearance-none block w-full px-3 py-3 border bg-white border-gray-100 rounded-full shadow-sm placeholder-gray-500 focus:outline-none focus:ring-[#383D4E] focus:border-[#383D4E] text-gray-800 sm:text-sm',
          className
        )}
        onChange={onChange}
        {...registration}
      />
    </FieldWrapper>
  );
};
